/**
 * Necklace collection markers — client-side fallback when Chrome serves stale HTML
 * or section morph replaces grid markup without data attributes.
 */
(function () {
  const NECKLACE_COLLECTION_PATH = /\/collections\/(?:judyladies-)?necklace(?:\/|$|[?#])/i;

  function isNecklaceCollectionPage() {
    return NECKLACE_COLLECTION_PATH.test(window.location.pathname);
  }

  function applyNecklaceCollectionMarkers() {
    if (!isNecklaceCollectionPage()) return;

    document.documentElement.dataset.judyNecklaceCollection = 'true';

    if (document.body instanceof HTMLElement) {
      document.body.dataset.judyNecklaceCollection = 'true';
      document.body.classList.add('judy-necklace-collection-template');
    }

    document.querySelectorAll('results-list, ul[data-layout="judy"]').forEach((node) => {
      if (node instanceof HTMLElement) {
        node.dataset.judyNecklaceCollection = 'true';
      }
    });
  }

  applyNecklaceCollectionMarkers();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyNecklaceCollectionMarkers, { once: true });
  }

  document.addEventListener('judy:collection-grid-updated', applyNecklaceCollectionMarkers);
})();
